import { Record as ImmutableRecord } from "immutable";

import type { TAuditLogAction } from "./actions.types";

export enum AuditLogEntityType {
  ACCESS_REVIEW = "accessReview",
  AGENT_TOKEN = "agentToken",
  API_TOKEN = "apiToken",
  APPROVAL_ALGORITHM = "approvalAlgorithm",
  APPROVAL_FLOWS_WEBHOOK = "approvalFlowsWebhook",
  AUDIT_LOG = "auditLog",
  AUDIT_LOGS_WEBHOOK = "auditLogsWebhook",
  BUNDLE = "bundle",
  ELIGIBLE_JIT_ACCESS = "eligibleJitAccess",
  HRMS = "hrms",
  IDP = "idp",
  INTEGRATION = "integration",
  INTEGRATION_RESOURCE = "integrationResource",
  INTEGRATION_RESOURCE_ROLE = "integrationResourceRole",
  JIT_ANALYSIS = "jitAnalysis",
  NOTIFICATION_INTEGRATION = "notificationIntegration",
  ORG_ROLE = "orgRole",
  ORGANIZATION = "organization",
  PERMISSION = "permission",
  POLICY = "policy",
  TASK = "task",
  TICKET = "ticket",
  TICKETS = "tickets",
  USER = "user",
}

export enum ExecuterApiTokenType {
  GLOBAL = "globalApiToken",
  MCP = "mcpToken",
  PERSONAL = "personalApiToken",
}

export type TExecuterApiToken = null | TGlobalApiToken | TMcpToken | TPersonalApiToken;

type TGlobalApiToken = {
  id: string;
  name: string;
  type: ExecuterApiTokenType.GLOBAL;
};

type TMcpToken = {
  type: ExecuterApiTokenType.MCP;
  user?: {
    email: null | string;
    id: null | string;
    name: null | string;
  };
};

type TPersonalApiToken = {
  id: string;
  name: string;
  type: ExecuterApiTokenType.PERSONAL;
  user?: {
    email: string;
    id: string;
    name: string;
  };
};

const defaults = {
  action: "" as TAuditLogAction,
  createdAt: new Date(0),
  data: {} as Record<string, unknown>,
  entityId: "",
  entityType: "" as AuditLogEntityType,
  executerApiToken: null as TExecuterApiToken,
  executerUserId: "" as null | string,
  id: "",
};

export class AuditLogModel<
  E extends AuditLogEntityType = AuditLogEntityType,
  A extends TAuditLogAction = TAuditLogAction,
  D extends Record<string, unknown> = Record<string, unknown>,
> extends ImmutableRecord<typeof defaults>(defaults) {
  declare action: A;
  declare data: D;
  declare entityType: E;

  static fromServerData(recordData: unknown) {
    const { action, createdAt, data, entityId, entityType, executerApiToken, executerUserId, id } =
      recordData as typeof defaults;

    return new AuditLogModel({
      action,
      createdAt: new Date(createdAt),
      data,
      entityId,
      entityType,
      executerApiToken,
      executerUserId,
      id,
    });
  }
}
